export default [
	{
		modulo: 4,
		privilegio: 4,
		routerName: 'rastreamento',
		routerPath: '/rastreamento',
		componentName: 'Rastreamento',
		componentPath: 'modules/layout/rastreamento/main'
	}
]
